import { Card, CardHeader, List } from '@material-ui/core';
import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import AffairListDetail from './AffairListDetail';

class AffairsAsCards extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let details = [];

        if (this.props.filteredAndSortedAffairs.length <= 0)
            return (
                <Card className="card">
                    <CardHeader title={"Aucun résultat"} className="text-center" titleTypographyProps={{ variant: "h6", color: 'primary' }} />
                </Card>
            );

        this.props.filteredAndSortedAffairs
            .filter((a) => !a.deleted)
            .forEach((a) => {
                details.push(
                    <AffairListDetail
                        globalContainer={this.props.globalContainer}
                        className="affair-list-detail"
                        key={a.code}
                        affair={a}
                    />
                );
            });

        return <List className="row">{details.map((d) => d)}</List>;
    }
}

export default AffairsAsCards;
